import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from 'rxjs/operators';

import {getUrlParams} from "../lib/lib";
import {Injectable} from "@angular/core";
import * as dictionary from "../../dict/static.json";

const config: any = dictionary['config'];

@Injectable()
export class DataProvider {
	baseRoute: string = config.backendPrefix;
	
	constructor(public http: HttpClient) {
		
	}
	
	getUrl(endpoint: string) {
		return `${this.baseRoute}${endpoint}`;
	}
	
	
	get(endpoint: string, queryParams?) {
		const
			url    = this.getUrl(endpoint),
			params = getUrlParams(queryParams);
		
		return this.http.get(`${url}?${params}`).pipe(
			map(r => r[1])
		);
	}
	
	
	post(endpoint: string, queryParams) {
		return this.http.post(this.getUrl(endpoint), queryParams).pipe(
			map(r => r[1])
		);
	}
	
	
	put(endpoint, queryParams) {
		return this.http.put(this.getUrl(endpoint), queryParams).pipe(
			map(r => r[1])
		);
	}
	
	
	delete(endpoint, queryParams?) {
		const endpount = this.getUrl(endpoint);
		
		let $r = null;
		
		if (queryParams) {
			$r = this.http.request('delete', endpount, {
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
				}),
				body: queryParams,
			});
		} else {
			$r = this.http.delete(endpount);
		}
		
		return $r.pipe(
			map(r => r[1])
		);
	}
}
